import { useGetUserNameWithFallback } from '@pba/react-utils';
import type { Kudo as KudoModel } from 'models';
import { Avatar, Flex, Icon, Text, Title } from 'ui';

type P = {
  kudo: KudoModel;
};

const Kudo = ({ kudo }: P) => {
  const { user } = kudo;
  const getUserNameWithFallback = useGetUserNameWithFallback();
  const fullName = getUserNameWithFallback(user);

  return (
    <Flex className="kudo" vertical>
      <Text className="kudo__header" size="large" weight="bold">
        Kudos to...
      </Text>

      <Flex align="center" flex={1} gap="xs" justify="center" vertical>
        <Avatar size="xl" src={user.profilePhoto}>
          {fullName}
        </Avatar>

        <Title className="kudo__user-name" level={1}>
          {fullName}
        </Title>

        <Icon className="kudo__bg-icon" icon="medal-line" />
      </Flex>
    </Flex>
  );
};

export default Kudo;
